import React from "react";
import styled from "styled-components";
import Logo from "./logo";

const Banner = styled.div`
  height: 50px;
  background: #f8f8f8;
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-bottom: 10px;
  font-size: 18px;
  font-family: gotham-500;
`;

const HeaderContainer = styled.div`
  margin: 18px 0;
`;
const Title = styled.div`
  font-family: gotham-500;
  font-size: 20px;
`;

function Layout({ banner, header, children }) {
  return (
    <div>
      <Logo></Logo>
      {banner ? <Banner>{banner}</Banner> : null}
      <div className="inner-wrapper">
        <HeaderContainer>
          <Title className="page-title">{header}</Title>
        </HeaderContainer>
        {children}
      </div>
    </div>
  );
}

export default Layout;
